import React from 'react';
import { Link } from 'react-router-dom';
import red_arrow from '../../assets/sprites/red_arrow.svg';

interface GoToLinkProps {
  to: string;
  state?: any;
  text?: string;
}

const GoToLink = ({ to, state, text = 'Перейти' }: GoToLinkProps) => {
  return (
    <Link
      to={to}
      state={state}
      className="flex justify-end text-red-600 no-underline gap-0.5 z-[2] text-xs font-montserrat font-semibold leading-7"
    >
      <span>{text}</span>
      <img src={red_arrow} alt="" aria-hidden="true" />
    </Link>
  );
};

export default GoToLink;
